var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 14.9998V14.3332C23.3333 13.3997 23.3333 12.933 23.1517 12.5765C22.9919 12.2629 22.7369 12.0079 22.4233 11.8482C22.0668 11.6665 21.6001 11.6665 20.6667 11.6665H19.3333C18.3999 11.6665 17.9332 11.6665 17.5767 11.8482C17.2631 12.0079 17.0081 12.2629 16.8483 12.5765C16.6667 12.933 16.6667 13.3997 16.6667 14.3332V14.9998M18.3333 19.5832V23.7498M21.6667 19.5832V23.7498M12.5 14.9998H27.5M25.8333 14.9998V24.3332C25.8333 25.7333 25.8333 26.4334 25.5608 26.9681C25.3212 27.4386 24.9387 27.821 24.4683 28.0607C23.9335 28.3332 23.2335 28.3332 21.8333 28.3332H18.1667C16.7665 28.3332 16.0665 28.3332 15.5317 28.0607C15.0613 27.821 14.6788 27.4386 14.4392 26.9681C14.1667 26.4334 14.1667 25.7333 14.1667 24.3332V14.9998",
    stroke: "#D92D20",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconRed);
export default __webpack_public_path__ + "static/media/delete-icon-red.811b0f0504965d8ef9ef30ccc32f6b13.svg";
export { ForwardRef as ReactComponent };